<template>
  <page-header-wrapper>
    <template v-slot:content>
      <div class="home-container">
        <a-spin :spinning="loading">
          <div class="welcome-section">
            <div class="welcome-content">
              <h1 class="welcome-title">沄境礼品卡 · 数据概览</h1>
              <p class="welcome-subtitle">{{ currentDate }} · 实时业务统计</p>
            </div>
          </div>

          <a-row :gutter="16" class="stat-row">
            <a-col :xs="12" :sm="8" :md="4">
              <a-card :bordered="false" class="stat-card">
                <a-statistic title="用户总数" :value="stats.userTotal || 0">
                  <template #prefix><a-icon type="team" /></template>
                </a-statistic>
              </a-card>
            </a-col>
            <a-col :xs="12" :sm="8" :md="4">
              <a-card :bordered="false" class="stat-card stat-card-highlight">
                <a-statistic title="今日新增" :value="stats.todayNewUsers || 0" :value-style="{ color: '#1890ff' }">
                  <template #prefix><a-icon type="user-add" /></template>
                </a-statistic>
                <div class="stat-sub">昨日 {{ stats.yesterdayNewUsers || 0 }} · 7日 {{ stats.sevenNewUsers || 0 }}</div>
              </a-card>
            </a-col>
            <a-col :xs="12" :sm="8" :md="4">
              <a-card :bordered="false" class="stat-card">
                <a-statistic title="本月注册合计" :value="stats.monthNewUsers || 0" :value-style="{ color: '#13c2c2' }">
                  <template #prefix><a-icon type="calendar" /></template>
                </a-statistic>
              </a-card>
            </a-col>
            <a-col :xs="12" :sm="8" :md="4">
              <a-card :bordered="false" class="stat-card">
                <a-statistic title="兑换订单" :value="stats.redeemOrderTotal || 0">
                  <template #prefix><a-icon type="gift" /></template>
                </a-statistic>
                <div class="stat-sub">今日 {{ stats.todayRedeemOrders || 0 }} 笔</div>
              </a-card>
            </a-col>
            <a-col :xs="12" :sm="8" :md="4">
              <a-card :bordered="false" class="stat-card">
                <a-statistic title="今日兑换金额" :value="stats.todayRedeemAmount || 0" :precision="2" :group-separator="''">
                  <template #prefix><a-icon type="pay-circle" /></template>
                </a-statistic>
              </a-card>
            </a-col>
            <a-col :xs="12" :sm="8" :md="4">
              <a-card :bordered="false" class="stat-card">
                <a-statistic title="提现申请" :value="stats.withdrawTotal || 0">
                  <template #prefix><a-icon type="transaction" /></template>
                </a-statistic>
                <div class="stat-sub">今日 {{ stats.todayWithdrawOrders || 0 }} 笔</div>
              </a-card>
            </a-col>
          </a-row>

          <a-row :gutter="16" class="stat-row" style="margin-top: 16px">
            <a-col :xs="12" :sm="8" :md="8">
              <a-card :bordered="false" class="stat-card">
                <a-statistic title="未提现积分" :value="stats.unwithdrawnBalance || 0" :precision="2" :group-separator="''" :value-style="{ color: '#fa8c16' }">
                  <template #prefix><a-icon type="wallet" /></template>
                </a-statistic>
                <div class="stat-sub">全部客户钱包余额合计</div>
              </a-card>
            </a-col>
            <a-col :xs="12" :sm="8" :md="8">
              <a-card :bordered="false" class="stat-card">
                <a-statistic title="今日提现" :value="stats.todayWithdrawAmount || 0" :precision="2" :group-separator="''" :value-style="{ color: '#52c41a' }">
                  <template #prefix><a-icon type="money-collect" /></template>
                </a-statistic>
                <div class="stat-sub">今日已打款金额</div>
              </a-card>
            </a-col>
            <a-col :xs="12" :sm="8" :md="8">
              <a-card :bordered="false" class="stat-card">
                <a-statistic title="本月提现总和" :value="stats.monthWithdrawAmount || 0" :precision="2" :group-separator="''" :value-style="{ color: '#722ed1' }">
                  <template #prefix><a-icon type="fund" /></template>
                </a-statistic>
                <div class="stat-sub">本月已打款金额合计</div>
              </a-card>
            </a-col>
          </a-row>

          <a-row :gutter="16" style="margin-top: 16px">
            <a-col :xs="24" :md="8">
              <a-card title="待办事项" :bordered="false" class="enhanced-card">
                <div class="todo-item" @click="goRedeem">
                  <span>兑换待审核</span>
                  <a-badge :count="redeemPending" :overflow-count="999" />
                </div>
                <div class="todo-item" @click="goWithdraw">
                  <span>提现待审核</span>
                  <a-badge :count="withdrawPending" :overflow-count="999" />
                </div>
                <div v-if="showCsTodo" class="todo-item" @click="goCsWorkbench">
                  <span>客服待处理</span>
                  <a-badge :count="csUnread" :overflow-count="999" />
                </div>
                <a-divider style="margin: 12px 0" />
                <div class="todo-total">
                  合计待处理 <strong>{{ todoTotal }}</strong> 项
                </div>
              </a-card>
            </a-col>
            <a-col :xs="24" :md="16">
              <a-card title="近 7 日新增用户" :bordered="false" class="enhanced-card">
                <div ref="userChart" class="chart-box" />
              </a-card>
            </a-col>
          </a-row>

          <a-row :gutter="16" style="margin-top: 16px">
            <a-col :span="24">
              <a-card title="近 7 日订单趋势" :bordered="false" class="enhanced-card">
                <div ref="orderChart" class="chart-box chart-box-wide" />
              </a-card>
            </a-col>
          </a-row>
        </a-spin>
      </div>
    </template>
  </page-header-wrapper>
</template>

<script>
import { PageHeaderWrapper } from '@/components/ProLayout'
import * as echarts from 'echarts'
import { mapGetters } from 'vuex'
import { getDashboard } from '@/api/giftcard/dashboard'
import { navigateToCsWorkbench } from '@/utils/csEmbed'

export default {
  name: 'Index',
  components: { PageHeaderWrapper },
  data() {
    return {
      loading: false,
      currentTime: new Date(),
      stats: {},
      userChart: null,
      orderChart: null
    }
  },
  computed: {
    ...mapGetters(['auditRedeemPending', 'auditWithdrawPending', 'csUnreadTotal', 'permissions']),
    redeemPending() {
      return Number(this.auditRedeemPending) || 0
    },
    withdrawPending() {
      return Number(this.auditWithdrawPending) || 0
    },
    csUnread() {
      return Number(this.csUnreadTotal) || 0
    },
    showRedeemTodo() {
      const perms = this.permissions || []
      return perms.includes('giftcard:redeem:list') || perms.includes('*:*:*')
    },
    showWithdrawTodo() {
      const perms = this.permissions || []
      return perms.includes('giftcard:withdraw:list') || perms.includes('*:*:*')
    },
    showCsTodo() {
      const perms = this.permissions || []
      return perms.includes('customer:workbench:view') || perms.includes('*:*:*')
    },
    todoTotal() {
      let total = 0
      if (this.showRedeemTodo) total += this.redeemPending
      if (this.showWithdrawTodo) total += this.withdrawPending
      if (this.showCsTodo) total += this.csUnread
      return total
    },
    currentDate() {
      return this.currentTime.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      })
    }
  },
  mounted() {
    this.loadDashboard()
    this.$store.dispatch('auditReminder/fetchAuditPendingCount')
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.userChart) this.userChart.dispose()
    if (this.orderChart) this.orderChart.dispose()
  },
  methods: {
    loadDashboard() {
      this.loading = true
      getDashboard().then(res => {
        this.stats = res.data || {}
        this.$nextTick(() => {
          this.renderUserChart()
          this.renderOrderChart()
        })
      }).finally(() => {
        this.loading = false
      })
    },
    formatChartDates(list) {
      return (list || []).map(item => {
        const parts = (item.date || '').split('-')
        return parts.length >= 3 ? `${parts[1]}-${parts[2]}` : item.date
      })
    },
    renderUserChart() {
      const el = this.$refs.userChart
      if (!el) return
      if (!this.userChart) {
        this.userChart = echarts.init(el)
      }
      const list = this.stats.dailyNewUsers || []
      this.userChart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 40, right: 20, top: 20, bottom: 30 },
        xAxis: {
          type: 'category',
          data: this.formatChartDates(list),
          boundaryGap: false
        },
        yAxis: { type: 'value', minInterval: 1 },
        series: [{
          name: '新增用户',
          type: 'line',
          smooth: true,
          areaStyle: { color: 'rgba(24, 144, 255, 0.15)' },
          itemStyle: { color: '#1890ff' },
          data: list.map(i => i.count || 0)
        }]
      })
    },
    renderOrderChart() {
      const el = this.$refs.orderChart
      if (!el) return
      if (!this.orderChart) {
        this.orderChart = echarts.init(el)
      }
      const redeem = this.stats.dailyRedeemOrders || []
      const withdraw = this.stats.dailyWithdrawOrders || []
      const dates = this.formatChartDates(redeem.length ? redeem : withdraw)
      this.orderChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['兑换订单', '提现申请'] },
        grid: { left: 40, right: 20, top: 40, bottom: 30 },
        xAxis: { type: 'category', data: dates },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          {
            name: '兑换订单',
            type: 'bar',
            barMaxWidth: 28,
            itemStyle: { color: '#52c41a' },
            data: redeem.map(i => i.count || 0)
          },
          {
            name: '提现申请',
            type: 'bar',
            barMaxWidth: 28,
            itemStyle: { color: '#faad14' },
            data: withdraw.map(i => i.count || 0)
          }
        ]
      })
    },
    handleResize() {
      if (this.userChart) this.userChart.resize()
      if (this.orderChart) this.orderChart.resize()
    },
    goRedeem() {
      this.$router.push({ path: '/giftcard/redeem' })
    },
    goWithdraw() {
      this.$router.push({ path: '/giftcard/withdraw' })
    },
    goCsWorkbench() {
      navigateToCsWorkbench(this.$router, this.$store)
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  padding: 24px;
}

.welcome-section {
  background: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);
  border-radius: 12px;
  padding: 28px 32px;
  margin-bottom: 20px;
  color: #333;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  .welcome-title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #1d39c4;
  }

  .welcome-subtitle {
    font-size: 14px;
    opacity: 0.85;
    margin: 0;
  }
}

.stat-row {
  .stat-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 16px;
    min-height: 108px;
  }

  .stat-card-highlight {
    border-top: 3px solid #1890ff;
  }

  .stat-sub {
    margin-top: 8px;
    font-size: 12px;
    color: #999;
  }
}

.enhanced-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}

.todo-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }
}

.todo-total {
  color: #666;
  font-size: 13px;
}

.chart-box {
  width: 100%;
  height: 260px;
}

.chart-box-wide {
  height: 300px;
}
</style>
